<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="forgot-pass-page">
  <div class="forgot-pass-form">
    <div class="invalid-feedback" style="display: block; text-align: center" *ngIf="errorMsg">{{errorMsg}}</div>
    <form [formGroup]="forGotPasswordForm" class="security-form">
      <ul>
        <li>
          <label> New Password</label>
          <div class="pass-fld">
            <input id="visibility1" type="password" formControlName="password"
                   [ngClass]="{ 'is-invalid': isSubmitted && f.password.errors }"  (keyup) = "keyUp($event);checkpasswordvalid($event.target.value)"/>
            <div *ngIf="isSubmitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">Please re-enter your password</div>
              
            </div>
            <div class="invalid-feedback" style="display: block" >{{passerr2}}</div>
            <span class="vis-pass" [ngClass]="status ? 'active' : ''" (click)="showPass()"> <i class="fa fa-eye"></i>
                </span>
          </div>
        </li>
        <li>

          <label> Confirm Password</label>
          <div class="pass-fld">
            <input id="visibility2" type="password" formControlName="cpassword"
                   [ngClass]="{ 'is-invalid': isSubmitted && f.cpassword.errors }" (keyup) = "keyUp($event)"/>
            <div *ngIf="isSubmitted && f.cpassword.errors" class="invalid-feedback">
              <div *ngIf="f.cpassword.errors.required">Please re-enter your password</div>
              <div *ngIf="f.cpassword.errors.passwordNotMatch">Please check that your passwords match</div>

            </div>

            <span class="vis-pass" [ngClass]="status2 ? 'active' : ''" (click)="showPass2()"> <i class="fa fa-eye"></i>
                </span>
          </div>
        </li>
      </ul>
      <div class="text-center"> <a href="javascript:void(0)" class="btn" (click)="updatePassword()">
        Update </a>
      </div>
    </form>
  </div>
</div>
